import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { NgxSpinnerService } from 'ngx-spinner';
import { Apiservice } from '../../services/api.service';
import { ComponentService } from '../../services/component.service';
import { IModelloStampa, ModelliStampaService } from '../../services/modelli-stampa.service';
import { AzioniFirDigitaliEnum, AzioniFirDigitaliKey, Sede } from '../../views/gestione-formulari/interfaces';
import { Comuni, FirRemoto, OperazioniDisponibili, OutputEventCampi, OutputEventCampiErrors, OutputEventCampiStatus, OutputEventCampiValue, Soggetto } from './interfaces';
import { alert, custom } from 'devextreme/ui/dialog';
import { DocumentTask, FirDigitaliTransactionService, TransactionStateMap } from '../../services/fir-digitali-transaction.service';
import { takeUntil } from 'rxjs/operators';
import { Subject, Subscription } from 'rxjs';
import { UtilityService } from '../../services/utility.service';
import { DxTagBoxComponent } from 'devextreme-angular';
import { v1 as uuidv1 } from 'uuid';
import { Utenteservice } from '../../services/utente.service';
import { ToolbarComponent } from '../toolbar/toolbar.component';

export type FileRentriResponse = {
  nome_file: string
  mime: string
  content: string
  size: number
}

@Component({
  selector: 'app-popup-gestione-fir-digitali',
  templateUrl: './popup-gestione-fir-digitali.component.html',
  styleUrls: ['./popup-gestione-fir-digitali.component.css']
})
export class PopupGestioneFirDigitaliComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('tagBox', { static: false }) tagBox: DxTagBoxComponent
  @ViewChild('menuBottom', { static: false }) menuBottom: ToolbarComponent
  @Input() firRemoto: FirRemoto
  @Input() soggetto: Soggetto
  @Input() operazioniDisponibili: OperazioniDisponibili
  @Input() guid: string
  @Output() eventEmitter: EventEmitter<any> = new EventEmitter()
  buttonCustomBottom = [
    {
      id: 'submit',
      text: 'Invia',
      icon: 'dx-icon-greater',
      disabled: true,
      visible: true,
      hint: 'Invia',
      name: 'submit',
      location: 'before',
      widget: 'button',
    }
  ]
  actionKeys: any[] = []
  sectionKeys: { [key: string]: string[] } = {}

  toolbarSelect = [
    { id: 'DatiAccettazione', value: 'Dati Accettazione', disabled: false, meta: {} },
    { id: 'AggiungiAnnotazione', value: 'Aggiungi Annotazione', disabled: false, meta: {} },
    { id: 'Annullamento', value: 'Annullamento', disabled: false, meta: {} },
    { id: 'AggiungiNuovoDestinatario', value: 'Aggiungi Nuovo Destinatario', disabled: false, meta: {} },
    // { id: 'AcquisizioneFirma', value: 'Acquisizione Firma', disabled: false, meta: {} },
    { id: 'AggiungiAllegato', value: 'Aggiungi Allegato', disabled: false, meta: {} },
    { id: 'DatiTrasporto', value: 'Dati Trasporto', disabled: false, meta: {} },
    { id: 'DatiQuantitaOrigine', value: 'Dati Quantità Origine', disabled: false, meta: {} },
  ]
  toolbarSelectedValue: any[] = [];
  pdfUrl: SafeResourceUrl | undefined;

  private moment = require('moment')
  private errorsFormsMap: { [key: string]: Partial<OutputEventCampiErrors> } = {}
  private statusFormsMap: { [key: string]: Partial<OutputEventCampiStatus> } = {}
  private valueFormsMap: { [key: string]: Partial<OutputEventCampiValue> } = {}
  private readonly $destroy: Subject<void> = new Subject()
  private readonly exludeAction = [
    'Hash', 'Rilascia', 'Reset', 'SostaTecnica',
    'TrasbordoParziale', 'TrasbordoTotale', 'AcquisizioneFirmaSostaTecnica', 'AcquisizioneFirmaTrasbordoParziale', 'AcquisizioneFirmaTrasbordoTotale',]
  private readonly buttonAction = [
    'RollbackFirma',
    'AcquisizioneFirma',
    'AcquisizioneFirmaAccettazioneSuccessiva',
    'AcquisizioneFirmaAnnotazione',
    'AcquisizioneFirmaAnnullamento',
    'AcquisizioneFirmaDestinatario',
    'AcquisizioneFirmaDestinatarioSuccessivo',
    'AcquisizioneFirmaProduttore',
    'AcquisizioneFirmaProduttoreTrasportatore',
    'AcquisizioneFirmaTrasportatore',
    // 'AcquisizioneFirmaSostaTecnica',
    // 'AcquisizioneFirmaTrasbordoParziale',
    // 'AcquisizioneFirmaTrasbordoTotale',
  ]
  constructor(private readonly ComponentService: ComponentService,
    private readonly ApiService: Apiservice,
    private readonly sanitizer: DomSanitizer,
    private readonly loader: NgxSpinnerService,
    private readonly FirTransaction: FirDigitaliTransactionService,
    private readonly UtilityService: UtilityService,
    private readonly Utenteservice: Utenteservice
  ) { }

  ngAfterViewInit(): void {
    console.log(this)
  }
  ngOnDestroy(): void {
    this.$destroy.next()
    this.$destroy.complete()
  }
  async ngOnInit() {
    console.log({
      'firRemoto': this.firRemoto,
      'operazioniDisponibili': this.operazioniDisponibili,
      'soggetto': this.soggetto,
      'guid': this.guid,
    })
    const keys = Object.keys(AzioniFirDigitaliEnum)
      .filter(k => isNaN(Number(k))) as AzioniFirDigitaliKey[];

    for (const k of keys) {
      if (this.exludeAction.includes(k)) continue;
      const isAvailable = this.operazioniDisponibili.azioni.includes(k);
      if (isAvailable && this.buttonAction.includes(k)) {
        const text = k.includes('AcquisizioneFirma') ? this.splitCamelCase('AcquisizioneFirma') : this.splitCamelCase(k)
        this.buttonCustomBottom.unshift({
          disabled: false,
          hint: this.splitCamelCase(k),
          icon: k.includes('AcquisizioneFirma') ? 'dx-icon-rename' : 'dx-icon-revert',
          id: k,
          location: 'before',
          name: k,
          visible: true,
          widget: 'button',
          text
        });
        continue;
      }
      this.paintFormData(k, isAvailable);
    }
    if (this.firRemoto) {
      await this.processModelloPdf(this.firRemoto);
    }
    // this.FirTransaction.isProcessing$.pipe(takeUntil(this.$destroy)).subscribe((val) => {
    //   this.buttonCustomBottom[0].disabled = val
    // })
    this.FirTransaction.state$.pipe(takeUntil(this.$destroy)).subscribe({
      next: async (next: TransactionStateMap) => {
        if (next[this.firRemoto.dati_partenza.numero_fir] && next[this.firRemoto.dati_partenza.numero_fir].lastTask && next[this.firRemoto.dati_partenza.numero_fir].lastTask !== 'InvioFirDigitale') {
          if (next[this.firRemoto.dati_partenza.numero_fir].listTask.every((task) => task.status === 'completed')) {
            await this.refresh()
            this.eventEmitter.emit({ event: 'transaction', error: next[this.firRemoto.dati_partenza.numero_fir].status === 'error' })
          }
        }
      },
    })

  }
  everyFalse(key) {
    if (this.toolbarSelect.find((val) => val.id === key)) {
      const meta = this.toolbarSelect.find((val) => val.id === key).meta
      return Object.keys(meta).every((k) => meta[k] === false)
    } else return true
  }
  splitCamelCase(str: any): string {
    if (!str) return '';
    str = String(str);
    return str
      .replace(/([a-z])([A-Z])/g, '$1 $2')
      .replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2')
      .replace(/([0-9])([A-Za-z])/g, '$1 $2')
      .replace(/([A-Za-z])([0-9])/g, '$1 $2')
      .trim();
  }

  async toolbarBottomEmitted(event) {
    console.log(event)
    if (event === 0) {
      this.ComponentService.destroyCurrentOpenPopUpByGuid(this.guid);
      return;
    }
    if (event === 'submit') {
      const valid: boolean[] = []
      const msg = []
      this.toolbarSelect.forEach((section) => {
        const statusForm = this.statusFormsMap[section.id];
        if (!statusForm) return;
        const statusFormGroup = this.statusFormsMap[section.id].formGroups
        if (!statusFormGroup) return;
        statusFormGroup.markAllAsTouched();
        statusFormGroup.updateValueAndValidity();
        if (!statusForm) return
        if (statusForm.status === 'INVALID' && statusForm.touched === true) {
          valid.push(false)
          this.errorsFormsMap[section.id].errors.forEach(err => {
            msg.push(`<p class="mb-2">${err}</p>`)
          })
          console.log({
            statusFormsMap: this.statusFormsMap,
            errorsFormsMap: this.errorsFormsMap,
            valueFormsMap: this.valueFormsMap
          })
        } else valid.push(true)
      })
      console.log({
        statusFormsMap: this.statusFormsMap,
        errorsFormsMap: this.errorsFormsMap,
        valueFormsMap: this.valueFormsMap
      })
      if (valid.every(val => val === true)) {
        return await this.submit()
      } else if (msg.length === 0) {
        return alert('Errore interno nell\'invio dei dati. Riprovare più tardi', 'Attenzione')
      } else {
        return alert(`<div>${msg.filter((val) => val !== null && val !== undefined && val !== '').join('')}</div>`, 'Attenzione')
      }
    }
    if (typeof event === 'string' && this.buttonAction.includes(event) && event.includes('AcquisizioneFirma')) {
      await this.processaFirma(event as AzioniFirDigitaliKey)
    }
    if (typeof event === 'string' && event === 'RollbackFirma') {
      await this.FirTransaction.enqueueAction({
        endpoint: `/rentri/fir-digitali/${this.firRemoto.dati_partenza.numero_fir}/RollbackFirma?idSoggetto=${this.soggetto.id}`,
        idSoggetto: this.soggetto.id,
        processId: 'RollbackFirma',
        numeroFormulario: this.firRemoto.dati_partenza.numero_fir,
        title: `${this.firRemoto.dati_partenza.numero_fir}: Rollback Firma`,
        getTransaction_id: async () =>
          await this.ApiService.PostApi(`rentri/fir-digitali/${this.firRemoto.dati_partenza.numero_fir}/RollbackFirma?idSoggetto=${this.soggetto.id}`, null) as Promise<{ transazione_id: string }>
      })
      this.ComponentService.destroyCurrentOpenPopUpByGuid(this.guid)
    }
  }

  listenFieldEvent(event: OutputEventCampi) {
    switch (event.name) {
      case 'statusChange':
        this.statusFormsMap[event.sezione] = {
          status: event.status,
          formGroups: event.formGroups,
          component: event.component,
          touched: event.touched,
        }
        return
      case 'errorsChange':
        this.errorsFormsMap[event.sezione] = {
          errors: event.errors,
          formGroups: event.formGroups,
          component: event.component,
          touched: event.touched,
        }
        return
      case 'valueChange':
        this.valueFormsMap[event.sezione] = {
          value: event.value,
          formGroups: event.formGroups,
          component: event.component,
          touched: event.touched,
        }
        const submitBtn = this.buttonCustomBottom.find(val => val.id === 'submit')
        const firmaBtn = this.buttonCustomBottom.find(val => val.id.includes('AcquisizioneFirma'))
        const isTouch = (Object.entries(this.valueFormsMap).some(([key, val]) => val.touched === true))
        if (submitBtn) submitBtn.disabled = !isTouch;
        if (firmaBtn) firmaBtn.disabled = isTouch;
        if (submitBtn) this.menuBottom.changeStatusBtnBottom(submitBtn.id as any, isTouch)
        if (firmaBtn) this.menuBottom.changeStatusBtnBottom(firmaBtn.id as any, !isTouch)

        return
      case 'onInit':
        this.valueFormsMap[event.sezione] = {
          value: event.value,
          formGroups: event.formGroups,
          component: event.component,
          touched: event.touched,
        }
        return
      default:
        return
    }
  }

  //! ----------------------------------------------------- PRIVATE ----------------------------------------------------------------------
  private paintFormData(key: AzioniFirDigitaliKey, disponibile: boolean = false) {
    switch (key) {
      case 'Accettazione':
        if (this.sectionKeys['DatiAccettazione']) this.sectionKeys['DatiAccettazione'].push(key);
        else this.sectionKeys['DatiAccettazione'] = [key]
        if (this.toolbarSelect.find(t => t.id === 'DatiAccettazione'))
          this.toolbarSelect.find(t => t.id === 'DatiAccettazione')['meta'][key] = disponibile;
        break;
      case 'Annotazione':
        if (this.sectionKeys['AggiungiAnnotazione']) this.sectionKeys['AggiungiAnnotazione'].push(key);
        else this.sectionKeys['AggiungiAnnotazione'] = [key]
        if (this.toolbarSelect.find(t => t.id === 'AggiungiAnnotazione'))
          this.toolbarSelect.find(t => t.id === 'AggiungiAnnotazione')['meta'][key] = disponibile;
        break;
      case 'NoteAnnullamento':
      case 'Annulla':
        if (this.sectionKeys['Annullamento']) this.sectionKeys['Annullamento'].push(key);
        else this.sectionKeys['Annullamento'] = [key]
        if (this.toolbarSelect.find(t => t.id === 'Annullamento'))
          this.toolbarSelect.find(t => t.id === 'Annullamento')['meta'][key] = disponibile;
        break;
      case 'NuovoDestinatario':
        if (this.sectionKeys['AggiungiNuovoDestinatario']) this.sectionKeys['AggiungiNuovoDestinatario'].push(key);
        else this.sectionKeys['AggiungiNuovoDestinatario'] = [key]
        if (this.toolbarSelect.find(t => t.id === 'AggiungiNuovoDestinatario'))
          this.toolbarSelect.find(t => t.id === 'AggiungiNuovoDestinatario')['meta'][key] = disponibile;
        break;
      // case 'RollbackFirma':
      // case 'AcquisizioneFirma':
      // case 'AcquisizioneFirmaAccettazioneSuccessiva':
      // case 'AcquisizioneFirmaAnnotazione':
      // case 'AcquisizioneFirmaAnnullamento':
      // case 'AcquisizioneFirmaDestinatario':
      // case 'AcquisizioneFirmaDestinatarioSuccessivo':
      // case 'AcquisizioneFirmaProduttore':
      // case 'AcquisizioneFirmaProduttoreTrasportatore':
      // case 'AcquisizioneFirmaSostaTecnica':
      // case 'AcquisizioneFirmaTrasbordoParziale':
      // case 'AcquisizioneFirmaTrasbordoTotale':
      // case 'AcquisizioneFirmaTrasportatore':
      //   if (this.sectionKeys['AcquisizioneFirma']) this.sectionKeys['AcquisizioneFirma'].push(key);
      //   else this.sectionKeys['AcquisizioneFirma'] = [key]
      //   if (this.toolbarSelect.find(t => t.id === 'AcquisizioneFirma'))
      //     this.toolbarSelect.find(t => t.id === 'AcquisizioneFirma')['meta'][key] = disponibile;
      //   break;
      case 'Allegato':
        if (this.sectionKeys['AggiungiAllegato']) this.sectionKeys['AggiungiAllegato'].push(key);
        else this.sectionKeys['AggiungiAllegato'] = [key]
        if (this.toolbarSelect.find(t => t.id === 'AggiungiAllegato'))
          this.toolbarSelect.find(t => t.id === 'AggiungiAllegato')['meta'][key] = disponibile;
        break;
      case 'DatiQuantita':
      case 'DatiQuantitaUpdate':
        if (this.sectionKeys['DatiQuantitaOrigine']) this.sectionKeys['DatiQuantitaOrigine'].push(key);
        else this.sectionKeys['DatiQuantitaOrigine'] = [key]
        if (this.toolbarSelect.find(t => t.id === 'DatiQuantitaOrigine'))
          this.toolbarSelect.find(t => t.id === 'DatiQuantitaOrigine')['meta'][key] = disponibile;
        break;
      case 'Trasporto':
      case 'TrasportoUpdate':
        if (this.sectionKeys['DatiTrasporto']) this.sectionKeys['DatiTrasporto'].push(key);
        else this.sectionKeys['DatiTrasporto'] = [key]
        if (this.toolbarSelect.find(t => t.id === 'DatiTrasporto'))
          this.toolbarSelect.find(t => t.id === 'DatiTrasporto')['meta'][key] = disponibile;
        break;
      default:
        break;
    }
    if (this.tagBox) {
      this.tagBox.instance.repaint()
      this.tagBox.instance._refresh()
    }
    this.toolbarSelectedValue = []
  }
  private async refresh() {
    this.loader.show()
    try {
      const numero_fir = this.firRemoto.dati_partenza.numero_fir
      const identificativo_soggetto = this.soggetto.codiceFiscale
      this.firRemoto = await this.ApiService.GetApi(`rentri/fir-digitali/${numero_fir}?idSoggetto=${this.soggetto.id}`) as FirRemoto
      this.operazioniDisponibili = await this.ApiService.GetApi(`rentri/fir-digitali/${numero_fir}/GetOperazioniDisponibili?idSoggetto=${this.soggetto.id}&identificativo_soggetto=${identificativo_soggetto}`) as OperazioniDisponibili
      this.toolbarSelect = this.toolbarSelect.map((val) => { val.disabled = true; return val })
      const keys = Object.keys(AzioniFirDigitaliEnum)
        .filter(k => isNaN(Number(k))) as AzioniFirDigitaliKey[];
      this.buttonCustomBottom = [
        {
          id: 'submit',
          text: 'Invia',
          icon: 'dx-icon-greater',
          disabled: true,
          visible: true,
          hint: 'Invia',
          name: 'submit',
          location: 'before',
          widget: 'button',
        }
      ]
      for (const k of keys) {
        if (this.exludeAction.includes(k)) continue;
        const isAvailable = this.operazioniDisponibili.azioni.includes(k);
        if (isAvailable && this.buttonAction.includes(k)) {
          const text = k.includes('AcquisizioneFirma') ? this.splitCamelCase('AcquisizioneFirma') : this.splitCamelCase(k)
          this.buttonCustomBottom.unshift({
            disabled: false,
            hint: this.splitCamelCase(k),
            icon: k.includes('AcquisizioneFirma') ? 'dx-icon-rename' : 'dx-icon-revert',
            id: k,
            location: 'before',
            name: k,
            visible: true,
            widget: 'button',
            text
          });
          this.menuBottom.disegna()
          continue;
        }
        this.paintFormData(k, isAvailable);
      }
    } catch { } finally { this.loader.hide() }
  }
  private async submit() {
    try {
      for (const section of this.toolbarSelect) {
        if (!this.valueFormsMap[section.id]) continue;
        if (this.valueFormsMap[section.id].touched !== true) continue;
        const values = this.valueFormsMap[section.id].value;
        if (!values) continue;
        for (const action of this.sectionKeys[section.id]) {
          if (section.meta[action] === false) continue;
          const formData = values[action];
          if (!formData) continue;
          switch (action) {
            case 'Accettazione':
              const Accettazione = JSON.parse(JSON.stringify(formData))
              Accettazione.quantita_accettata = {
                valore: formData.quantita_accettata
              }
              console.log(action, Accettazione);
              await this.FirTransaction.enqueueAction({
                endpoint: `/rentri/fir-digitali/${this.firRemoto.dati_partenza.numero_fir}/Accettazione?idSoggetto=${this.soggetto.id}`,
                idSoggetto: this.soggetto.id,
                processId: action,
                numeroFormulario: this.firRemoto.dati_partenza.numero_fir,
                title: `${this.firRemoto.dati_partenza.numero_fir}: Inserimento Accettazione`,
                getTransaction_id: async () =>
                  await this.ApiService.PostApi(`rentri/fir-digitali/${this.firRemoto.dati_partenza.numero_fir}/Accettazione?idSoggetto=${this.soggetto.id}`, Accettazione) as Promise<{ transazione_id: string }>
              })
              break;
            case 'Annotazione':
              const Annotazione = JSON.parse(JSON.stringify(formData))
              Annotazione.identificativo_soggetto = this.soggetto.codiceFiscale
              console.log(action, Annotazione);
              await this.FirTransaction.enqueueAction({
                endpoint: `/rentri/fir-digitali/${this.firRemoto.dati_partenza.numero_fir}/Annotazione?idSoggetto=${this.soggetto.id}`,
                idSoggetto: this.soggetto.id,
                processId: action,
                numeroFormulario: this.firRemoto.dati_partenza.numero_fir,
                title: `${this.firRemoto.dati_partenza.numero_fir}: Inserimento Annotazione`,
                getTransaction_id: async () =>
                  await this.ApiService.PostApi(`rentri/fir-digitali/${this.firRemoto.dati_partenza.numero_fir}/Annotazione?idSoggetto=${this.soggetto.id}`, Annotazione) as Promise<{ transazione_id: string }>
              })
              break;
            case 'NoteAnnullamento':
              const NoteAnnullamento = JSON.parse(JSON.stringify(formData))
              console.log(action, NoteAnnullamento);
              await this.FirTransaction.enqueueAction({
                endpoint: `/rentri/fir-digitali/${this.firRemoto.dati_partenza.numero_fir}/NoteAnnullamento?idSoggetto=${this.soggetto.id}`,
                idSoggetto: this.soggetto.id,
                processId: action,
                numeroFormulario: this.firRemoto.dati_partenza.numero_fir,
                title: `${this.firRemoto.dati_partenza.numero_fir}: Aggiunta Nota Annullamento`,
                getTransaction_id: async () =>
                  await this.ApiService.PostApi(`rentri/fir-digitali/${this.firRemoto.dati_partenza.numero_fir}/NotaAnnullamento?idSoggetto=${this.soggetto.id}`, { note: NoteAnnullamento.note }) as Promise<{ transazione_id: string }>
              })
              break;
            case 'Annulla':
              const Annulla = JSON.parse(JSON.stringify(formData))
              Annulla.codice_fiscale_soggetto = this.soggetto.codiceFiscale
              console.log(action, Annulla);
              await this.FirTransaction.enqueueAction({
                endpoint: `/rentri/fir-digitali/${this.firRemoto.dati_partenza.numero_fir}/Annulla?idSoggetto=${this.soggetto.id}`,
                idSoggetto: this.soggetto.id,
                processId: action,
                numeroFormulario: this.firRemoto.dati_partenza.numero_fir,
                title: `${this.firRemoto.dati_partenza.numero_fir}: Annullamento`,
                getTransaction_id: async () =>
                  await this.ApiService.PostApi(`rentri/fir-digitali/${this.firRemoto.dati_partenza.numero_fir}/Annulla?idSoggetto=${this.soggetto.id}`, undefined) as Promise<{ transazione_id: string }>
              })
              break;
            case 'NuovoDestinatario':
              const NuovoDestinatario = {
                autorizzazione: {
                  numero: formData.autorizzazione.numero,
                  tipo: formData.autorizzazione.tipoAutorizzazioneRentriCodice
                },
                attivita: formData.attivita,
                numero_iscrizione_albo: formData.unita_locale.numeroIscrizioneAlbo,
                denominazione: formData.destinatario.ragioneSociale,
                codice_fiscale: formData.destinatario.codiceFiscale,
                nazione_id: formData.unita_locale.stato,
                indirizzo: {
                  citta: {
                    ...(formData.unita_locale.stato === 'IT' ?
                      { comune_id: formData.unita_locale.istatComune } :
                      { nazione_id: formData.unita_locale.stato, nome_citta: formData.unita_locale.comune }
                    )
                  },
                  indirizzo: formData.unita_locale.indirizzo,
                  civico: formData.unita_locale.civico,
                  cap: formData.unita_locale.cap
                }
              }
              console.log(action, NuovoDestinatario);
              await this.FirTransaction.enqueueAction({
                endpoint: `/rentri/fir-digitali/${this.firRemoto.dati_partenza.numero_fir}/NuovoDestinatario?idSoggetto=${this.soggetto.id}`,
                idSoggetto: this.soggetto.id,
                processId: action,
                numeroFormulario: this.firRemoto.dati_partenza.numero_fir,
                title: `${this.firRemoto.dati_partenza.numero_fir}: Inserimento Nuovo Destinatario`,
                getTransaction_id: async () =>
                  await this.ApiService.PostApi(`rentri/fir-digitali/${this.firRemoto.dati_partenza.numero_fir}/NuovoDestinatario?idSoggetto=${this.soggetto.id}`, NuovoDestinatario) as Promise<{ transazione_id: string }>
              })
              break;
            // case 'RollbackFirma':
            //   console.log(action, formData);
            //   break;
            // case 'AcquisizioneFirma':
            // case 'AcquisizioneFirmaAccettazioneSuccessiva':
            // case 'AcquisizioneFirmaAnnotazione':
            // case 'AcquisizioneFirmaAnnullamento':
            // case 'AcquisizioneFirmaDestinatario':
            // case 'AcquisizioneFirmaDestinatarioSuccessivo':
            // case 'AcquisizioneFirmaProduttore':
            // case 'AcquisizioneFirmaProduttoreTrasportatore':
            // case 'AcquisizioneFirmaSostaTecnica':
            // case 'AcquisizioneFirmaTrasbordoParziale':
            // case 'AcquisizioneFirmaTrasbordoTotale':
            // case 'AcquisizioneFirmaTrasportatore':
            //   await this.processaFirma(action)
            //   break;
            case 'Allegato':
              console.log(action, formData);
              const file: File = formData.allegato[0]
              if (!file) return alert('Erroe nell\'invio dell\'Allegato', 'Attenzione')
              const contenuto = await this.UtilityService.toPureBase64(file)
              if (!contenuto) return alert('Erroe nell\'invio dell\'Allegato', 'Attenzione')
              const Allegato = {
                content_type: file.type,
                nome_file: file.name,
                contenuto,
                identificativo_soggetto: this.soggetto.codiceFiscale
              }
              await this.FirTransaction.enqueueAction({
                endpoint: `/rentri/fir-digitali/${this.firRemoto.dati_partenza.numero_fir}/Allegato?idSoggetto=${this.soggetto.id}`,
                idSoggetto: this.soggetto.id,
                processId: action,
                numeroFormulario: this.firRemoto.dati_partenza.numero_fir,
                title: `${this.firRemoto.dati_partenza.numero_fir}: Aggiunta Allegato`,
                getTransaction_id: async () => await this.ApiService.PostApi(`rentri/fir-digitali/${this.firRemoto.dati_partenza.numero_fir}/Allegato?idSoggetto=${this.soggetto.id}`, Allegato) as Promise<{ transazione_id: string }>
              })
              break;
            case 'DatiQuantita':
            case 'DatiQuantitaUpdate':
              const DatiQuantita = {
                quantita: {
                  valore: formData.quantita,
                  unita_misura: formData.unita_misura
                },
                verificato_in_partenza: formData.verificato_in_partenza
              }
              console.log(action, DatiQuantita);
              await this.FirTransaction.enqueueAction({
                endpoint: `/rentri/fir-digitali/${this.firRemoto.dati_partenza.numero_fir}/Quantita?idSoggetto=${this.soggetto.id}`,
                idSoggetto: this.soggetto.id,
                processId: action,
                numeroFormulario: this.firRemoto.dati_partenza.numero_fir,
                title: action === 'DatiQuantita' ? `${this.firRemoto.dati_partenza.numero_fir}: Inserimento Quantità` : `${this.firRemoto.dati_partenza.numero_fir}: Aggiornamento Quantità`,
                getTransaction_id: async () => await this.ApiService.PostApi(`rentri/fir-digitali/${this.firRemoto.dati_partenza.numero_fir}/Quantita?idSoggetto=${this.soggetto.id}`, DatiQuantita) as Promise<{ transazione_id: string }>
              })
              break;
            case 'Trasporto':
            case 'TrasportoUpdate':
              const Trasporto = JSON.parse(JSON.stringify(formData))
              let trasportoUrl = ''
              if (!('tipo_trasporto' in Trasporto)) return alert('Errore interno nell\'invio dei Dati Trasporto. Riprovare più tardi', 'Attenzione')
              if (Trasporto.tipo_trasporto === 'Terrestre') {
                trasportoUrl = 'TrasportoTerrestre'
                const conducente = Trasporto.conducente.split(' ')
                if (!conducente) return
                Trasporto.conducente = {
                  cognome: conducente[0],
                  nome: conducente[1]
                }
                console.log(action, Trasporto);
              } else if (Trasporto.tipo_trasporto === 'Marittimo') trasportoUrl = 'TrasportoMarittimo';
              else if (Trasporto.tipo_trasporto === 'Ferroviario') trasportoUrl = 'TrasportoFerroviario';
              else return alert('Errore interno nell\'invio dei Dati Trasporto. Riprovare più tardi', 'Attenzione');
              delete Trasporto.tipo_trasporto
              await this.FirTransaction.enqueueAction({
                endpoint: `/rentri/fir-digitali/${this.firRemoto.dati_partenza.numero_fir}/${trasportoUrl}?idSoggetto=${this.soggetto.id}`,
                idSoggetto: this.soggetto.id,
                processId: action,
                numeroFormulario: this.firRemoto.dati_partenza.numero_fir,
                title: action === 'Trasporto' ? `${this.firRemoto.dati_partenza.numero_fir}: Inserimento Trasportatore` : `${this.firRemoto.dati_partenza.numero_fir}: Aggiornamento Trasportatore`,
                getTransaction_id: async () => await this.ApiService.PostApi(`rentri/fir-digitali/${this.firRemoto.dati_partenza.numero_fir}/${trasportoUrl}?idSoggetto=${this.soggetto.id}`, Trasporto) as Promise<{ transazione_id: string }>
              })
              break;
            default:
              break;
          }
        }
      }
    } catch (errore) {
      console.error(errore)
      alert('Errore interno nell\'invio dei dati', 'Attenzione')
      this.eventEmitter.emit({ event: 'submit', error: true })
    } finally {
      this.eventEmitter.emit({ event: 'submit', error: false })
      this.ComponentService.destroyCurrentOpenPopUpByGuid(this.guid)
    }
  }

  private async processaFirma(action: AzioniFirDigitaliKey | 'InvioFirDigitale') {
    this.loader.show()
    try {
      if (!action) return alert('Errore sconosciuto nel processo di firma', 'Errore Interno');
      const title = `${this.firRemoto.dati_partenza.numero_fir}: ${action === 'AcquisizioneFirmaProduttoreTrasportatore' ? 'Acquisizione Firma Produttore' : this.splitCamelCase(action)}`
      const utente: any = this.Utenteservice.InfoUtenteConnesso as any
      if (!utente.nome || !utente.cognome) return alert('Nome e cognome dell\'utente assenti', 'Attenzione');
      const devices = await this.ApiService.GetApi(`ca-rentri/CredentialDevices?idSoggetto=${this.soggetto.id}&identificativo_soggetto=${this.soggetto.codiceFiscale}&$filter=(contains(tolower(utente_nome_cognome), tolower('${utente.nome} ${utente.cognome}')))`) as any
      if (!devices || !devices.items || devices.items.length === 0) return alert('Nessun dispositivo associaito per l\'utente corrente', 'Attenzione');
      else if (devices.items && devices.items.length > 1) {
        const guid = uuidv1()
        console.log(guid)
        const instanceData = {
          soggetto: this.soggetto,
          elimina: false,
          seleziona: true,
          isUlSelection: false,
          aggiungi: false,
          isStatic: true,
          dataSource: devices.items
        }
        this.loader.hide()
        this.ComponentService.setNewPopUp(guid, 'GestioneDispositiviComponent', null, '-webkit-fill-available', null, instanceData, false, true, title, 'top')
        const sub: Subscription = this.ComponentService.outputComponent.subscribe(async (out) => {
          if (out.guid === guid) {
            console.log(out)
            if (out.event && out.name === "onSelectionChanged") {
              const credentials_id = out.event.selectedRowKeys[0]
              if (!credentials_id) return
              await this.FirTransaction.enqueueAction({
                endpoint: `${action}-${this.firRemoto.dati_partenza.numero_fir}`,
                idSoggetto: this.soggetto.id,
                processId: action,
                numeroFormulario: this.firRemoto.dati_partenza.numero_fir,
                title,
                credentials_id
              })
              await this.sendFirma({ action, credentials_id, title })
              this.ComponentService.destroyCurrentOpenPopUpByGuid(guid)
              sub.unsubscribe()
            }
          }
        })
      } else {
        const credentials_id = devices.items[0].credentials_id
        if (!credentials_id) return alert('Nessun identificativo del dispositivo trovato', 'Attenzione');
        return await this.sendFirma({ action, credentials_id, title })
      }
    } catch { } finally {
      this.loader.hide()
    }
  }

  private async sendFirma({ action, title, credentials_id }) {
    await this.FirTransaction.enqueueAction({
      endpoint: `${action}-${this.firRemoto.dati_partenza.numero_fir}`,
      idSoggetto: this.soggetto.id,
      processId: action,
      numeroFormulario: this.firRemoto.dati_partenza.numero_fir,
      title,
      credentials_id
    })
    const sub: Subscription = this.FirTransaction.lastFirma$.pipe(takeUntil(this.$destroy)).subscribe({
      next: async (next: DocumentTask & { data: { [key: string]: any } } | undefined | null) => {
        console.log(next)
        if (next !== null && next !== undefined) {
          if (next.status === 'completed') this.ComponentService.destroyCurrentOpenPopUpByGuid(this.guid)
          if (next.status !== 'pending') {
            if (this.FirTransaction.messaggioFirma) this.FirTransaction.messaggioFirma.hide()
            this.FirTransaction.messaggioFirma = undefined
            if (sub) sub.unsubscribe()
          }
        }
      },
    })
  }

  private async processModelloPdf(firRemoto: FirRemoto, action: 'download' | 'arraybuffer' = 'arraybuffer') {
    this.loader.show()
    try {
      const resFile: FileRentriResponse = await this.ApiService.GetApi(
        `rentri/fir-digitali/${this.firRemoto.dati_partenza.numero_fir}/pdf?idSoggetto=${this.soggetto.id}`
      ) as FileRentriResponse;
      const base64DataUrl = `data:${resFile.mime};base64,${resFile.content}`;
      const file = this.UtilityService.base64ToFileObj(
        base64DataUrl,
        resFile.nome_file
      );
      const url = URL.createObjectURL(file);
      this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);

    }
    catch (err) {
      this.pdfUrl = ''
    } finally {
      this.loader.hide()
    }
  }
}
